module.exports = __webpack_public_path__ + "static/media/magnat.ed1ed589.otf";